import React, { Fragment, useState } from "react";
import { Home } from "react-feather";
import { Link } from "react-router-dom";
import Bookmark from "./bookmark";

const Breadcrumb = (props) => {
  //console.log({props})
  const { title, parent } = props;
  // const [breadcrumb, setBreadcrumb] = useState(props);

  return (
    <Fragment>
      <div className="container-fluid" style={{margin:"15px 0px"}}>
        <div className="page-header">
          <div className="row">
            <div className="col">
              <div className="page-header-left"
              style={{display:"flex", alignItems:"center"}}
              >
                <h3
                  style={{
                    fontFamily: "proxima",
                    marginTop: "-6px",
                    textTransform:"uppercase",
                    fontSize:"22px"
                  }}
                >
                  {title}
                </h3>
                <ol
                  className="breadcrumb pull-right"
                  style={{ marginLeft: 15 }}
                >
                  <li className="breadcrumb-item">
                    {/* <Link to="/dashboard/default"> */}
                    {/* <Link to="/"> */}
                    <Home style={{ width: 20, height: 20, color: "#0088ff" }} />
                    {/* </Link> */}
                  </li>
                  <li
                    className="breadcrumb-item"
                    style={{ fontFamily: "proxima !important" }}
                  >
                    {parent}
                  </li>
                  <li
                    className="breadcrumb-item active"
                    style={{ fontFamily: "proxima !important" }}
                  >
                    {title}
                  </li>
                </ol>
              </div>
            </div>
            {/* <!-- Bookmark Start--> */}
            {/* <Bookmark /> */}
            {/* <!-- Bookmark Ends--> */}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Breadcrumb;
